import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import '../App.css';
// import '../auth.css';
import Paper from '@mui/material/Paper';
import { PageFooter } from '../Pages/HomePage';
import TopNav from '../Components/TopNav';

const ForgotPasswordPage = () => {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { forgotPassword } = useAuth();

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setError('');
      setMessage('');
      setLoading(true);
      await forgotPassword(email);
      setMessage('Check your email for password reset instructions');
    } catch (err) {
      setError(err.response?.data?.message || 'Failed to reset password');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-page-wrapper">
        <TopNav dark={true} customColor='bg-almost-black' transparent={false} />
      <div className="container">
        <div className="auth-section">
          <div className="col-xl-8 col-lg-8 col-md-10">
            <Paper elevation={3} className="auth-paper p-5 bg-dark text-light"> 
              <div className="card-body p-0">
                <div className="p-5">
                  <div className="text-center">
                    <h1 className="auth-title">Forgot Password</h1>
                  </div>
                  {error && <div className="alert alert-danger">{error}</div>}
                  {message && <div className="alert alert-success">{message}</div>}
                  <form className="user" onSubmit={handleSubmit}>
                    <div className="form-group">
                      <input
                        type="email"
                        className="form-control form-control-user"
                        placeholder="Enter Email Address..."
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        required
                      />
                    </div>
                    <button
                      type="submit"
                      className="btn btn-primary btn-user btn-block"
                      disabled={loading}
                    >
                      {loading ? 'Sending...' : 'Reset Password'}
                    </button>
                  </form>
                  <hr />
                  <div className="text-center">
                    <Link to="/login" className="text-gra font-weight-bold font-size-1em">
                      Back to Login
                    </Link>
                  </div>
                </div>
              </div>
            </Paper>
          </div>
        </div>
      </div>
      <PageFooter className='bg-almost-black' />
    </div>
  );
};

export default ForgotPasswordPage; 